import React from 'react';
import { useTranslation } from 'react-i18next';

import Popup from './Popup';
import { lang } from '../../utils/utils';

import CinedLogo from '../../assets/images/logo.svg';

export default function WelcomePopup(props) {
    const { i18n, t } = useTranslation();

    return (
        <Popup {...props}>
            <div>
                <div className="centeredContainer">
                    <img alt="CinEd Logo" src={CinedLogo} className="logo" />
                </div>

                <h2 className="modalTitleTD h3Text" lang={lang[i18n.language]}>
                    {t('Player.Welcome')}
                </h2>

                <div className="centeredContainer column">
                    <div className="descriptionContainer">
                        <div className="normalText">{t('Player.WelcomeDesc1')}</div>

                        <p className="normalText">{t('Player.WelcomeDesc2')}</p>
                    </div>
                </div>
            </div>
        </Popup>
    );
}
